import axios from 'axios';
import { useState, useEffect } from 'react';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

// Canonical product categories, in display order. Single source: backend constants.py.
export async function getCategories() {
  const res = await axios.get(`${API_BASE}/meta/categories`, { headers: authHeader() });
  return res.data.categories;
}

// Inventory sizes (incl. 'Free'). Single source: backend constants.py.
export async function getSizes() {
  const res = await axios.get(`${API_BASE}/meta/sizes`, { headers: authHeader() });
  return res.data.sizes;
}

// Age-based sizes (no 'Free') — for appointment/child sizing.
export async function getAgeSizes() {
  const res = await axios.get(`${API_BASE}/meta/age-sizes`, { headers: authHeader() });
  return res.data.sizes;
}

// Canonical use-case tags.
export async function getUseCases() {
  const res = await axios.get(`${API_BASE}/meta/use-cases`, { headers: authHeader() });
  return res.data.use_cases;
}

// Delivery ETA choices for the dispatch step. Single source: backend constants.py.
export async function getDispatchEtas() {
  const res = await axios.get(`${API_BASE}/meta/dispatch-etas`, { headers: authHeader() });
  return res.data.etas;
}

// Shared fetch-once hook factory: module-cached + state-backed so components
// re-render (and re-sort) when the list arrives.
function _makeListHook(fetcher) {
  let cache = null;
  let promise = null;
  return function useList() {
    const [list, setList] = useState(cache || []);
    useEffect(() => {
      if (cache) { setList(cache); return; }
      if (!promise) promise = fetcher().then(v => { cache = v; return v; });
      promise.then(setList).catch(() => {});
    }, []);
    return list;
  };
}

export const useSizes = _makeListHook(getSizes);       // inventory sizes (incl. Free)
export const useAgeSizes = _makeListHook(getAgeSizes);  // age sizes (no Free)
export const useCategories = _makeListHook(getCategories);  // canonical categories
export const useDispatchEtas = _makeListHook(getDispatchEtas);  // dispatch ETA choices
